import React                                                      from "react";
import { Node }                                                   from "@xyflow/react";
import { useEffect, useState }                                    from "react";
import { useSelector }                                            from "react-redux";
import ReactJson                                                  from 'react-json-view';
import Textarea                                                   from "@mui/joy/Textarea";
import AddIcon                                                    from '@mui/icons-material/Add';
import {
         Box,
         Card, 
         CardContent,
         List,
         ListItem,
         ListItemText,
         Switch,
         TextField,
         FormControl,
         Select,
         MenuItem,
         Divider,
         Snackbar,
         Alert,
         Typography,
         CircularProgress
       }                                                          from '@mui/material';
import { BglCloseButton, 
         BglPrimaryButton, 
         BglPrimarySmallButton 
       }                                                          from 'components/button/BglButtons';
import { ServerConfigsAPI }                                       from "apis/ServerConfigsAPI";
import { useGlobalConfig }                                        from "context/GlobalContext";
import { RunContextApp }                                          from "framework/RCApp";
import { APIData, GetValues }                                              from "types/cms/frontendTypes";
import { selectCMSSelectedPilotDocId, 
         selectCMSPilotList, 
       }                                                          from "store/dataReducers/cmsPilotSlice";
import { ServiceNodeData }                                        from "./CustomNode";
import { CreateConfig, 
         CreateConfigComponent 
       }                                                          from "./CreateConfigComponent";

const getListItem = (rc : RunContextApp, projectId : string, config : GetValues<"api::config.config">) => {

  const configType = config.configType
  const key = config.key
  const configValObj = rc.config.getConfig(projectId, configType, key)
  const configVal = configValObj ? configValObj.val : undefined

  const handleToggle = (event : React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    //rc.config.setConfig(10052, configType, key, newValue);
  }

  const handleNumberChange = (event : React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    //rc.config.setConfig(10052, configType, key, newValue);
  }

  const handleStringChange = (event : React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    //rc.config.setConfig(10052, configType, key, newValue);
  }

  return (
    <ListItem sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
      <ListItemText 
        primary={config.label}
        secondary={config.description}
        sx={{
          '& .MuiListItemText-primary': {
            wordWrap: 'break-word'
          },
          '& .MuiListItemText-secondary': {
            color: '#6d6d6d',
            maxWidth: '50%',
            wordWrap: 'break-word'
          }
        }}
      />

      { !configValObj && (
        <Typography variant="caption" color="text.secondary">No config value found</Typography>
      )}

      {
        configValObj && (
          <>
          {configValObj.type === "BOOLEAN" && (
            <Switch
              checked={configVal}
              onChange={handleToggle}  
            />
          )}
          {configValObj.type === "NUMBER" && (
            <TextField
              type="number"
              value={configVal} 
              onChange={handleNumberChange}
            />
          )}
          {configValObj.type === "STRING" && (
            <Textarea
              sx={{
                width: '500px',
                fontSize: '12px',
                padding: '10px',
                borderRadius: '4px',
                backgroundColor: '#f5f5f5'
              }}
              value={configVal} 
              onChange={handleStringChange}
            />
          )}
          {configValObj.type === "JSON" && (
            
            <ReactJson
              src={configVal}
              onEdit={(edit) => {
                const newValue = edit.updated_src;
                //rc.config.setConfig(10052, configType, key, newValue);
              }}
              onAdd={(add) => {
                const newValue = add.updated_src;
                //rc.config.setConfig(10052, configType, key, newValue);  
              }}
              onDelete={(del) => {
                const newValue = del.updated_src;
                //rc.config.setConfig(10052, configType, key, newValue);
              }}
              displayDataTypes={false}
              displayObjectSize={false}
              enableClipboard={false}
              quotesOnKeys={false}
              name={false}
              style={{
                width: '500px',
                maxHeight: '200px',
                overflowY: 'auto',
                fontSize: '12px',
                padding: '10px',
                borderRadius: '4px',
                backgroundColor: '#f5f5f5'
              }}
            />
    
          )}
          </>
        )
      }

      
      
    </ListItem>
  )
}

export interface CustomNodeConfigsProps {
  node: Node<ServiceNodeData>;
  handleSystemNodeUpdate : (node : APIData<"api::system-node.system-node">) => void;
}

export const CustomNodeConfigs = ({node, handleSystemNodeUpdate} : CustomNodeConfigsProps) => {

  const { rc } = useGlobalConfig()

  const [groupedConfigs, setGroupedConfigs] = useState<{[key: string]: GetValues<"api::config.config">[]}>({}); 
  
  const [isCreateConfigDialogOpen, setIsCreateConfigDialogOpen] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false)

  const selectedPilotDocId = useSelector(selectCMSSelectedPilotDocId)
  const utilityList = useSelector(selectCMSPilotList)

  const selectedUtility = utilityList.find((utility : any) => utility.documentId === selectedPilotDocId)! as any;
  
  const envs = selectedUtility.envs! as any
  const [selectedEnv, setSelectedEnv] = useState<GetValues<"shared.env">>(envs[0]);
  
  useEffect(() => {

    const loadConfigs = async () => {

      setLoading(true)

      const configs = node.data.configs;

      const grouped = configs.reduce((acc, config) => {
        const configType = config.configType;
        if (!acc[configType]) {
          acc[configType] = [];
        }
        acc[configType].push(config);
        return acc;
      }, {} as {[key: string]: GetValues<"api::config.config">[]});

      const configTypes = Object.keys(grouped)
      
      const configsResp = await ServerConfigsAPI.getServerConfigs(rc, selectedUtility.pilotId, configTypes)
      if (configsResp.error) {
        console.log(`Error`, configsResp.error);
        return
      }

      rc.config.setConfigTypeData(selectedUtility.pilotId, (configsResp.data as any).configs)
      
      setGroupedConfigs(grouped);
      setLoading(false)
    }

    loadConfigs()

  }, [node, selectedEnv]);

  const addConfig = () => {
    setIsCreateConfigDialogOpen(true);
  }

  const handleCreateConfig = async (config : CreateConfig) => {

    const existingConfig = node.data.configs.find((nodeConfig) => nodeConfig.key === config.configKey)
    if (existingConfig) {
      setError(`Config already mapped: ${config.configType} - ${config.configKey}`)
      return
    }

    const resp = await ServerConfigsAPI.createServerConfig(rc, selectedUtility.pilotId, node.id, config)
    if (resp.error) {
      setError(resp.error.message || "Error : Could not create config")
      console.error(resp.error)
      return
    }

    rc.config.addConfig(selectedUtility.pilotId, resp.data!.configType, resp.data!.key, (resp as any).configVal)

    const updatedSystemNode = (resp as any).sysNode
    handleSystemNodeUpdate(updatedSystemNode)

    setIsCreateConfigDialogOpen(false);
  }

  return (
    <Box sx={{ marginTop: '20px', marginBottom: '20px'}}>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Configurations</Typography> 
        <BglPrimarySmallButton 
          variant="contained" 
          startIcon={<AddIcon />}
          onClick={() => addConfig()}>
            Link Config
        </BglPrimarySmallButton>
      </div>

      {
        loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        )
      }

      { !loading && Object.keys(groupedConfigs).length === 0 && (
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography variant="bglSubtitle3" color="text.secondary">No configs linked</Typography>
            </CardContent>
          </Card>
        )
      }
      
      {!loading && Object.entries(groupedConfigs).map(([configType, configs]) => (
        <Card sx={{ mb: 2 }} key={configType}>
          
          <CardContent>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <FormControl sx={{ minWidth: 200, mr: 2 }}>

                <Select
                  labelId="env-select-label"
                  size="small"
                  value={selectedEnv.clientId}
                  sx={{ height: 32 }}
                  onChange={(event) => {
                    const env = envs.find((env : any) => env.clientId === event.target.value)
                    if (env) {
                      setSelectedEnv(env)
                    }
                  }}
                >
                  {envs.map((env : any) => (
                    <MenuItem key={env.clientId} value={env.clientId}>
                      {`${env.label} - ${env.region}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <List>
              {configs.map((config) => (
                <React.Fragment key={config.key}>
                  {getListItem(rc, selectedUtility.pilotId, config)}
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          </CardContent>
        </Card>        
      ))}

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <BglCloseButton sx={{ marginRight : '10px'}}>Reset</BglCloseButton>
        <BglPrimaryButton disabled>Save</BglPrimaryButton>
      </div>

      {isCreateConfigDialogOpen && (
        <CreateConfigComponent
          node={node}
          isOpen={isCreateConfigDialogOpen}
          onClose={() => setIsCreateConfigDialogOpen(false)}
          onSave={handleCreateConfig}
        />
      )}

      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        onClose={() => setError("")}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setError("")} severity="error">
          {error}
        </Alert>
      </Snackbar>

    </Box>

  );
};  